module.exports = __webpack_public_path__ + "img/version_1.3da0cc79.png";